const setVipStatusOpt = `
    mutation SetVipStatusOpt($input: SetCustomOptInput) {
        setVipStatusOpt(input: $input)
    }
`;

const isEmailAvailable = `
    query IsEmailAvailable($email: String!) {
        isEmailAvailable(email: $email) {
            is_email_available
        }
    }
`;

export default {
    setVipStatusOpt,
    isEmailAvailable,
};
